/* template */
<template><div :style="[(style)] | transRpxStyle" class="packet"><div class="sign-in"><div :class='("sign-activity "+(discountObj.point && "has-point"))'>周五 六 日低至<span class="cash"><span class="integer">{{ discountObj.integer }}</span><span class="point">{{ discountObj.point }}</span><span class="decimal">{{ discountObj.decimal }}</span></span>折</div><mpx-view v-for="(item, index) in (signList)" :key="item.index" :class='("sign-item "+(index >= 4 && "is-activity"))' @tap="switchCoupon(index)"><template v-if="(index < 4)"><div class="sign-day">{{ item.text }}</div><div class="sign-bonus"><mpx-image webp :src="(item.is_sign_in ? bonusImg.sign : bonusImg.common)" mode="widthFix" class="bonus-img"/></div></template><template v-else><div class="sign-bonus"><mpx-image webp :src="(item.is_sign_in ? activityBonusImg.sign : activityBonusImg.common)" mode="widthFix" class="bonus-img"/></div><div class="final-bonus" v-if="(index === 6)">签到大奖</div></template><div class="icon-arrow" v-if="(item.couponIsToday)"></div></mpx-view></div><div :class='("coupon-warp "+(!showReward && "is-reward"))'><div :style="[(couponStyle)] | transRpxStyle" class="coupon" v-if="(!(couponList && couponList.length) || !couponIsToday)"><template v-if="(couponInfo)"><div class="tip">{{ couponTypeTip }}</div><div class="info"><span class="cash">{{ couponInfo.max_benefit_capacity.value }}</span><span>{{ couponInfo.max_benefit_capacity.unit }}</span>打车券包</div><div class="desc"><template v-if="(showBonus)"><mpx-image src="https://ut-static.udache.com/webx/ut/OClMcUjGzWfbq6zx7XIBu.png" class="bonus-icon"/><span class="bonus-cash">{{ todayInfo.count }}</span></template>{{ todayInfo.desc }}<mpx-image @tap="toBonusRule" src="https://ut-static.udache.com/webx/ut/O31m-kg4Vnn6jq7QlD-t6.png" mode="widthFix" class="tip-icon" v-if="(todayInfo.is_today && todayInfo.is_sign_in)"/><div class="max-bonus" v-if="(todayInfo.max_count)">最高{{ todayInfo.max_count }}</div></div></template></div><div class="reward-list" v-else><div v-for="(item, index) in (couponList_real)" :key="item.index" class="reward-item"><div class="coupon-type">{{ item.typeName }}</div><div><span class="cash">{{ item.coupon.max_benefit_capacity.value }}</span><span class="unit">{{ item.coupon.max_benefit_capacity.unit }}</span></div><div class="reward-info"><div class="usage-limit">{{ item.coupon.usage_limit }}</div><div class="valid-period">{{ item.coupon.remark || item.coupon.name }}</div></div></div></div></div><mpx-button :class='("btn "+(!couponIsToday && "is-disable"))' @tap="click">{{ buttonText }}</mpx-button></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m69b974a1"}'>
  .packet
    width 750rpx
    height 980rpx
    padding-top 356rpx
    box-sizing border-box
    overflow hidden
    position relative
    .coupon-warp
      background-image: linear-gradient(0deg, #FEFAF3 2%, #FEEFDE 99%);
      border-radius: 30rpx;
      margin 30rpx auto 0
      width: 630rpx;
      height: 280rpx;
      &.is-reward
        margin 30rpx 60rpx 0
    .coupon, .reward-list
      position relative
      background-size cover
      box-sizing: border-box;
    .reward-list
      display flex
      // margin 30rpx 60rpx 0
      overflow-x: auto;
      padding 24rpx 0 14rpx
      .reward-item
        flex-shrink: 0;
        width 182rpx
        height 232rpx
        margin-left 8rpx
        background url(https://ut-static.udache.com/webx/ut/pMSkgQI2_I-jmvVG7idDY.png) center/cover no-repeat
        padding-top 28rpx
        text-align center
        box-sizing: border-box;
        position relative
        &:first-child
          margin-left 13rpx
        &:last-child
          margin-right 13rpx
        .coupon-type
          position absolute
          top 0
          left 0
          right 0
          font-family: PingFangSC-Semibold;
          font-size: 18rpx;
          color: #FDF6E1;
          font-weight: 600;
        .cash
          font-family: DIN-BlackItalic, DIN-BlackItalic-self;
          font-size: 70rpx;
          color: #F3443E;
          position relative
          bottom -4rpx
        .unit
          font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
          font-size: 28rpx;
          color: #F3443E;
        .usage-limit
          margin-bottom 8rpx
        .usage-limit, .valid-period
          font-family: PingFangSC-Medium;
          font-size: 18rpx;
          color: #AF5902;
          font-weight: 500;
          line-height 1
        .valid-period
          font-size: 16rpx;
        .reward-info
          position absolute
          left 0
          right 0
          bottom 0
          height 98rpx
          padding 0 8rpx
          display: flex;
          flex-direction: column;
          justify-content: center;
          box-sizing border-box
          padding-bottom 4rpx
    .coupon
      // margin 30rpx auto 0
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      font-size: 40rpx;
      color: #F3443E;
      letter-spacing: 1.82rpx;
      font-weight: 400;
      text-align center
      width 100%
      height 100%
      .tip
        box-sizing: border-box
        width: 58rpx;
        height: 28rpx;
        background: #FF4D47;
        border: 1px solid rgba(255,237,210,1);
        border-radius: 10rpx;
        text-align center
        line-height 28rpx
        position absolute
        right 64rpx
        top 71rpx
        font-family: PingFangSC-Semibold;
        font-size: 16rpx;
        color: #FFF7EC;
        font-weight: 600;
      .info
        position absolute
        top 54rpx
        left 0
        right 0
        .cash
          font-family: UniSansHeavyCapsItalic, UniSansHeavyCapsItalic-self;
          font-size: 80rpx;
          color: #F3443E;
          letter-spacing: 0;
          line-height: 1;
          position relative
          bottom -8rpx
          padding-right 5rpx
      .max-bonus
        height: 24rpx;
        background: #FF631E;
        border-radius: 15rpx 15rpx 15rpx 0
        font-family: AlibabaPuHuiTi-Regular;
        font-size: 16rpx;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;;
        line-height 24rpx
        padding 0 6rpx
        margin-left 10rpx
      .desc
        position absolute
        top 164rpx
        left 0
        right 0
        font-family: PingFangSC-Semibold;
        font-size: 18rpx;
        color: #AF5902;
        text-align: center;
        font-weight: 600;
        display flex
        align-items center
        justify-content: center;
        .bonus-icon
          width 20rpx
          height 20rpx
          margin-right 4rpx
        .bonus-cash
          font-family: UniSansHeavyCapsItalic, UniSansHeavyCapsItalic-self;;
          font-size: 24rpx;
          color: #FF631E;
          font-weight: 900;
          margin-right 10rpx
        .tip-icon
          width 19rpx
          margin-left 10rpx
    .btn
      margin 12rpx auto 53rpx
      width: 530rpx;
      height: 110rpx;
      background: #FF5000;
      background-image: linear-gradient(219deg, #FF6B00 0%, #FF5000 77%);
      border-radius: 55rpx;
      line-height 110rpx
      text-align center
      font-family: MF-YuanHei-Regular, MF-YuanHei-Regular-self;
      font-size: 56rpx;
      color: #FFF6E8;
      letter-spacing: 2rpx;
      text-shadow: 0 1px 0 rgba(255,240,213,0.70);
      font-weight: 400;
      &.is-disable
        background: #FF5000;
        background-image: linear-gradient(219deg, #BBB9B9 0%, #9F9F9F 77%);
        color: #FFFFFF;
    .sign-in
      padding 0 65rpx
      display flex
      align-items flex-end
      position relative
      .sign-activity
        box-sizing: border-box;
        position absolute
        right 35rpx
        // top -55rpx
        bottom: 98rpx;
        font-family: AlibabaPuHuiTi-Heavy, AlibabaPuHuiTi-Heavy-self;
        font-size: 26rpx;
        color: #FFFFFF;
        padding 0 28rpx 0 0
        display: flex;
        align-items: baseline;
        &.has-point
          bottom: 102rpx;
          padding 0 18rpx 0 0
          .cash
            position relative
            top 2rpx
            font-size: 35rpx;
            padding 0 2rpx 0 2rpx
            .integer
              font-size: 62rpx;
              position relative
              top 2rpx
        .cash
          font-family: DIN-BlackItalic, DIN-BlackItalic-self;
          font-size: 80rpx;
          color: #FFFFFF;
          font-weight: 400;
          position relative
          bottom -6rpx
          padding 0 4rpx
          .integer
            -webkit-text-stroke: 1px rgba(253,87,52,1);
      .sign-item
        box-sizing: border-box;
        padding 9rpx 0 10rpx
        width: 80rpx;
        height: 140rpx;
        background-image: linear-gradient(180deg, #FFF1EE 13%, #FFE0D9 98%);
        border-radius: 20rpx;
        margin-right 10rpx
        text-align center
        position relative
        .sign-day
          font-family: AlibabaPuHuiTi-Medium;
          font-size: 24rpx;
          color: #BC6908;
          letter-spacing: 0;
          font-weight: 500;
          margin-bottom 13rpx
        &.is-activity
          height: 80rpx;
          border-radius: 27.3rpx;
          padding-top 0
          background-image: linear-gradient(180deg, #FFF5F2 13%, #FFE0D9 98%);
          .sign-bonus
            margin-top: -6rpx;
        &:last-child
          margin-right 0
        .sign-bonus
          width 80rpx
          height 75rpx
          .bonus-img
            width 100%
        .final-bonus
          width: 92rpx;
          height: 28rpx;
          background url(https://ut-static.udache.com/webx/ut/lq5QgNGmLEHsQmkHGwxwm.png) center/cover no-repeat
          font-family: AlibabaPuHuiTi-Bold;
          font-size: 16rpx;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          font-weight: 800;
          position absolute
          bottom 0
          left: 0
          right: 0
          line-height 28rpx
        .icon-arrow
          position absolute
          bottom -46rpx
          left 50%
          width: 30rpx;
          height: 30rpx;
          background-image: linear-gradient(45deg, #FFE4DD 12%, #FEF0DE 50%, transparent 50%, transparent 100%)
          transform translateX(-50%) rotate(135deg)
          // background-image: linear-gradient(0deg, #FEFAF3 2%, #FFECD4 99%);
          border-bottom-left-radius 4rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m69b974a1"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./red-packet-sign.mpx.js?isComponent&outputPath=components%2Fred-packet-sign69b974a1%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./red-packet-sign.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fred-packet-sign69b974a1%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m69b974a1"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/red-packet-sign69b974a1/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
